import { Routes, Route } from "react-router-dom"
import Login from "./pages/Login"
import Dashboard from "./pages/Dashboard"
import Forgotpassword from "./pages/Forgotpassword"
import Resetpassword from "./pages/Resetpassword"
import AuthGuard from "./hooks/AuthGuard"
import LoginRestrict from "./hooks/LoginRestrict"
import Customers from "./pages/Customers/Customers"
import CustomerDetail from "./pages/Customers/CustomerDetail"
import CustomerEdit from "./pages/Customers/CustomerEdit"
import CustomerBill from "./pages/Customers/CustomerBill"
import CustomerInvoice from "./pages/Customers/CustomerInvoice"
import PaymentSetting from "./pages/Payment/PaymentSetting"
import Subscriptions from "./pages/Subscriptions/Subscriptions"
import TermsLogs from "./pages/TermsLogs/TermsLogs"
import ChangePassword from "./pages/ChangePassword/ChangePassword"
import Devices from "./pages/Devices/Devices"
import Locations from "./pages/Locations/Locations"
import FloorPlans from "./pages/Locations/FloorPlans"
import Sensors from "./pages/Locations/Sensors"
import LocationDetail from "./pages/Locations/LocationDetail"
import LocationDeviceDetail from "./pages/Locations/DeviceDetail"
import SensorsList from "./pages/Sensors/SensorsList"
import SendNotification from "./pages/SendNotification/SendNotification"
import AppVersions from "./pages/AppVersions/AppVersions"
import SensorSosSettings from "./pages/SensorSosSettings/SensorSosSettings"
import AddSensorSosSettings from "./pages/SensorSosSettings/add/AddSensorSosSettings"
import EditSensorSosSettings from "./pages/SensorSosSettings/edit/editSensorSosSettings"
import SensorSOSEvents from "./pages/SensorSOSEvents/SensorSOSEvents"
import AddCustomer from "./pages/Customers/AddCustomer"
import LawEnforcementDomain from "./pages/LawEnforcementDomain/LawEnforcementDomain"
import AddOrUpdateLawEnforcement from "./pages/LawEnforcementDomain/AddOrUpdateLawEnforcement"
import SchoolDomain from "./pages/SchoolDomain/SchoolDomain"
import AddOrUpdateSchoolDomain from "./pages/SchoolDomain/AddOrUpdateSchoolDomain"

const RouterMain = () => {
  return (
    <Routes>
      {/* LOGIN ROUTES */}
      <Route
        path='/login'
        element={
          <LoginRestrict>
            <Login />
          </LoginRestrict>
        }
      />
      <Route path='/forgotpassword' element={<Forgotpassword />} />
      <Route path='/resetpassword/:token' element={<Resetpassword />} />

      {/* ADMIN ROUTES (No Outlet) */}
      <Route
        path='/'
        element={
          <AuthGuard>
            <Dashboard />
          </AuthGuard>
        }
      />
      <Route
        path='/customers'
        element={
          <AuthGuard>
            <Customers />
          </AuthGuard>
        }
      />

      <Route
        path='/customer/view/:id'
        element={
          <AuthGuard>
            <CustomerDetail />
          </AuthGuard>
        }
      />

      <Route
        path='/customer/edit/:id'
        element={
          <AuthGuard>
            <CustomerEdit />
          </AuthGuard>
        }
      />

      <Route
        path='/customer/bills/:id'
        element={
          <AuthGuard>
            <CustomerBill />
          </AuthGuard>
        }
      />

      <Route
        path='/customer/invoice/:id'
        element={
          <AuthGuard>
            <CustomerInvoice />
          </AuthGuard>
        }
      />

      <Route
        path='/paymentSetting'
        element={
          <AuthGuard>
            <PaymentSetting />
          </AuthGuard>
        }
      />

      <Route
        path='/location/floorPlans/:id'
        element={
          <AuthGuard>
            <FloorPlans />
          </AuthGuard>
        }
      />

      <Route
        path='/location/sensors/:id'
        element={
          <AuthGuard>
            <Sensors />
          </AuthGuard>
        }
      />

      <Route
        path='/location/view/:id'
        element={
          <AuthGuard>
            <LocationDetail />
          </AuthGuard>
        }
      />

      <Route
        path='/location/device-details/:id'
        element={
          <AuthGuard>
            <LocationDeviceDetail />
          </AuthGuard>
        }
      />

      <Route
        path='/subscriptions'
        element={
          <AuthGuard>
            <Subscriptions />
          </AuthGuard>
        }
      />

      <Route
        path='/devices'
        element={
          <AuthGuard>
            <Devices />
          </AuthGuard>
        }
      />

      <Route
        path='/locations'
        element={
          <AuthGuard>
            <Locations />
          </AuthGuard>
        }
      />

      <Route
        path='/sensors-list'
        element={
          <AuthGuard>
            <SensorsList />
          </AuthGuard>
        }
      />

      <Route
        path='/termsLogs'
        element={
          <AuthGuard>
            <TermsLogs />
          </AuthGuard>
        }
      />

      <Route
        path='/changePassword'
        element={
          <AuthGuard>
            <ChangePassword />
          </AuthGuard>
        }
      />

      {/* Fallback route (optional) */}
      <Route
        path='/*'
        element={
          <AuthGuard>
            <Dashboard />
          </AuthGuard>
        }
      />

      <Route
        path='/send-notification'
        element={
          <AuthGuard>
            <SendNotification />
          </AuthGuard>
        }
      />

      <Route
        path='/app-version'
        element={
          <AuthGuard>
            <AppVersions />
          </AuthGuard>
        }
      />

      <Route
        path='/sensor-sos-settings'
        element={
          <AuthGuard>
            <SensorSosSettings />
          </AuthGuard>
        }
      />

      <Route
        path='/sensor-sos-settings/add'
        element={
          <AuthGuard>
            <AddSensorSosSettings />
          </AuthGuard>
        }
      />

      <Route
        path='/sensor-sos-settings/edit/:id'
        element={
          <AuthGuard>
            <EditSensorSosSettings />
          </AuthGuard>
        }
      />

      <Route
        path='/sensor-sos-events'
        element={
          <AuthGuard>
            <SensorSOSEvents />
          </AuthGuard>
        }
      />

      <Route
        path='/law-enforcement-domain'
        element={
          <AuthGuard>
            <LawEnforcementDomain />
          </AuthGuard>
        }
      />

      <Route
        path='/law-enforcement-domain/add'
        element={
          <AuthGuard>
            <AddOrUpdateLawEnforcement />
          </AuthGuard>
        }
      />

      <Route
        path='/law-enforcement-domain/edit/:id'
        element={
          <AuthGuard>
            <AddOrUpdateLawEnforcement />
          </AuthGuard>
        }
      />

      <Route
        path='/school-domain'
        element={
          <AuthGuard>
            <SchoolDomain />
          </AuthGuard>
        }
      />

      <Route
        path='/school-domain/add'
        element={
          <AuthGuard>
            <AddOrUpdateSchoolDomain />
          </AuthGuard>
        }
      />

      <Route
        path='/school-domain/edit/:id'
        element={
          <AuthGuard>
            <AddOrUpdateSchoolDomain />
          </AuthGuard>
        }
      />

      <Route
        path='/customer/add'
        element={
          <AuthGuard>
            <AddCustomer />
          </AuthGuard>
        }
      />
    </Routes>
  )
}

export default RouterMain
